angular.module('unica_grand_prix.grand_prix_services')

.factory('GrandPrixRankingEditService', function ($http, getBaseApiURL) {

	var rankingEditService = {};


	rankingEditService.updateStatus = function ( rankingId, status )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/grand-prix/ranking/update-status/' + rankingId,
			data: {
				status: status
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.ranking;
			}

		});
	};


	rankingEditService.rejectPreInvitation = function ( preInvitationId )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/grand-prix/ranking/reject-pre-invitation/' + preInvitationId,
			data: {
				status: status
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};


	rankingEditService.confirmPreInvitation = function ( preInvitationId )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/grand-prix/ranking/confirm-pre-invitation/' + preInvitationId,
			data: {
				status: status
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};



	rankingEditService.sessionLock = function ( rankingId, hash )
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/grand-prix/ranking/session-lock/' + rankingId,
			data: {
				hash: hash
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};


	rankingEditService.awardNotAccepted = function( rankingId )
	{
		var url  = getBaseApiURL + '/grand-prix/ranking/award-not-accepted/' + rankingId;

		return $http({
			method: 'post',
			url: url,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};


	rankingEditService.reset = function( rankingId )
	{
		var url  = getBaseApiURL + '/grand-prix/ranking/reset/' + rankingId;

		return $http({
			method: 'post',
			url: url,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};


	rankingEditService.saveFirstStep = function( rankingId, preInvitationsData )
	{
		var url  = getBaseApiURL + '/grand-prix/ranking/save-first-step/' + rankingId;

		return $http({
			method: 'post',
			url: url,
			data: {
				pre_invitations: preInvitationsData
			}
		}).then(function(result) {

			if ( result && result.data ) {
				return result.data;
			}

		});
	};


	rankingEditService.saveSecondStep = function( rankingId, preInvitationsData )
	{
		var url  = getBaseApiURL + '/grand-prix/ranking/save-second-step/' + rankingId;

		return $http({
			method: 'post',
			url: url,
			data: {
				pre_invitations: preInvitationsData
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};


	rankingEditService.saveThirdStep = function( rankingId, preInvitationsData )
	{
		var url  = getBaseApiURL + '/grand-prix/ranking/save-third-step/' + rankingId;

		return $http({
			method: 'post',
			url: url,
			data: {
				pre_invitations: preInvitationsData
			}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	return rankingEditService;

});